import React, { memo } from "react";
import { BsCamera } from "react-icons/bs";
import { AiOutlineCamera } from "react-icons/ai";
import { RiDeleteBinLine } from "react-icons/ri";
import Avatar from "react-avatar-edit";
import Dropdown from "react-bootstrap/Dropdown";
import ModalPopup from "@components/Common/ModalPopup";
import styles from "@components/Common/Profile.module.css";

/**
 * ProfileImage component - Handles profile image display and upload/delete
 */
const ProfileImage = memo(({
  imageUrl,
  defaultImage,
  imgCrop,
  isModalOpen,
  validationError,
  onOpenModal,
  onCloseModal,
  onCrop,
  onBeforeFileLoad,
  onSaveImage,
  onRemoveImage,
}) => {
  return (
    <div className={`col-md-12 text-center ${styles.profile_InnerBox}`}>
      <img
        className={`mb-2 ${styles.profile_image}`}
        src={imageUrl || defaultImage}
        alt="Profile"
      />
      
      <Dropdown>
        <Dropdown.Toggle className={styles.profile_dropdown}>
          <BsCamera className={styles.profile__menuIcon} />
        </Dropdown.Toggle>
        
        <Dropdown.Menu className={styles.profile__dropdownMenu}>
          <Dropdown.Item
            href="#/action-1"
            className={styles.profile__dropdownItems}
            onClick={onOpenModal}
          >
            <AiOutlineCamera className={styles.profile_editIcon} /> Upload Image
          </Dropdown.Item>
          <hr />
          <Dropdown.Item
            href="#/action-1"
            className={`${styles.profile__dropdownItems} ${styles.Profile_dropdownLabel}`}
            onClick={onRemoveImage}
          >
            <RiDeleteBinLine className={styles.profile_removeIcon} /> Remove Image
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <ModalPopup
        className="ModalPopup_EditProfileSubmit"
        isModalOpen={isModalOpen}
        setIsModalOpen={onCloseModal}
        backdrop={true}
        fade={false}
        toShowBody={false}
        icon={
          <div className={`text-center ${styles.profile_model}`}>
            <Avatar
              width={200}
              height={200}
              onClose={onCloseModal}
              onCrop={onCrop}
              onBeforeFileLoad={onBeforeFileLoad}
            />
          </div>
        }
        showButton={
          <div className="text-center">
            <p
              className={
                validationError
                  ? `${styles.profile_errorActive}`
                  : `${styles.profile_error}`
              }
            >
              {validationError || "Please upload Professional Image"}
            </p>
            <button
              className={styles.profile_saveButton}
              onClick={onSaveImage}
              disabled={Boolean(validationError)}
            >
              Save
            </button>
          </div>
        }
      />
    </div>
  );
});

ProfileImage.displayName = "ProfileImage";

export default ProfileImage;
